import { log } from "@antv/g2plot/lib/utils";
import { Button, Checkbox, Col, Form, Input, notification, Radio, Row, Select } from "antd"
import { useEffect, useState } from "react";
import { addHerbManagementApi, listOfIngredientUnitApi, listOfRecipeTagsApi, updateHerbManagementApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, PHONE_PATTERN } from "../../../../../config/constant";
import { FilterApiData } from "../../../../../services/FilterApiData";
import '../style/HerbsManagement.scss'


export const AddHerbsDetails = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    // console.log(props);


    const [buttonName, setButtonName] = useState('ADD')
    const [kaphaValue, setKaphaValue] = useState(false)
    const [pittaValue, setPittaValue] = useState(false)
    const [vataValue, setVataValue] = useState(false)
    const [phenoTypeErrMsg, setPhenoTypeErrMsg] = useState('')
    const [arrayOfSelectedDropdownValue, setArrayOfSelectedDropdownValue] = useState([])
    const [recipeTagsOptions, setRecipeTagsOptions] = useState([])

    const [nutritionistType, setNutritionistType] = useState('');
    const [userRole, setUserRole] = useState('');

    const [unitOptionsList, setUnitOptionsList] = useState([]);

    // get the list of alll Recipe Tags  
    const getListOfRecipeTags = () => {
        listOfRecipeTagsApi()
            .then((res) => {
                if (res.status === 200) {
                    setRecipeTagsOptions(FilterApiData(res.data.data));
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get the list of alll available plans 
    const getlistOfIngredientUnit = () => {
        listOfIngredientUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setUnitOptionsList(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        getListOfRecipeTags()
        getlistOfIngredientUnit()

        let NutritionistType = JSON.parse(localStorage.getItem('user'))
        setNutritionistType(NutritionistType?.user?.type_of_account)
        setUserRole(NutritionistType?.user?.role)

        if (props.editHerbManagement) {
            setButtonName('UPDATE')
            let data = props.editHerbManagementRecord
            // console.log(data);
            if (props.editHerbManagementRecord) {

                form.setFieldsValue({
                    'herb_name': data.herb,
                    'quantity': data.quantity,
                    'unit': data?.unit?.id,
                    // 'kapha':data.kapha,
                    // 'pitta': data.pitta,
                    // 'vata': data.vata,
                    'remark': data.remark,
                    'typeOfHerb': data.typeOfHerb,
                })

                // set pheno type values
                setKaphaValue(data.kapha)
                setPittaValue(data.pitta)
                setVataValue(data.vata)


                // set all recipe tag values and fill it in form

                const temp = [{ fieldName: 'type_of_diet_tag', tag_type: "Type of Diet Tags" },
                { fieldName: 'cooking_method_tag', tag_type: "Recipe by Cooking Method Tags" },
                { fieldName: 'recipe_by_season_tag', tag_type: "Recipe by seasons Tags" },
                { fieldName: 'recipe_difficulty_level_tag', tag_type: "Recipe by difficulty level Tags" },
                { fieldName: 'other_tag', tag_type: "Other Tags" },
                { fieldName: 'allergy_tag', tag_type: "Allergy Tags" },
                { fieldName: 'disease_tag', tag_type: "Disease Tags" },
                { fieldName: 'nutrient_tags', tag_type: "Nutrient Tags" },
                { fieldName: 'cuisine_tags', tag_type: "Cuisine Tags" },
                { fieldName: 'goal_tag', tag_type: "Goal Tags" }]
                temp.map((record) =>
                    form.setFieldsValue(
                        { [record.fieldName]: data?.herb_tag?.filter((element) => element?.tag?.tagType == record.tag_type).map(a => (a.tag_id)) })
                )
                setArrayOfSelectedDropdownValue(data?.herb_tag)

            }

        }
    }, [props.editHerbManagementRecord])


    // here create an array of object all tags related selected dropdown values 
    // =================================    
    const CreateArrayOfSelectedValue = (id, task) => {
        // console.log(id);
        // console.log(task);
        let object = recipeTagsOptions.find((element) => element.id == id)
        if (task == "add") {
            // if selected option object is available inside array only push if not available
            let valueExist = arrayOfSelectedDropdownValue.find((element) => element.tag_id == object.id)
            // console.log(arrayOfSelectedDropdownValue);
            if (!valueExist) {
                object.tag_id = object.id
                // console.log(object,valueExist);

                arrayOfSelectedDropdownValue.push(object)
            }
            // console.log(arrayOfSelectedDropdownValue);
        }
        if (task == "remove") {
            const indexOfElement = arrayOfSelectedDropdownValue.findIndex((record) => record.tag_id == object.id);
            arrayOfSelectedDropdownValue.splice(indexOfElement, 1);
            // console.log(arrayOfSelectedDropdownValue);
        }
    }


    const onFinish = (values) => {
        let validation = false;
        if (kaphaValue == false && pittaValue == false && vataValue == false) {
            return setPhenoTypeErrMsg("Select Phenotypes")
        }


        const data = {
            "herb": values.herb_name,
            "quantity": values.quantity,
            "unit_id": values.unit,
            "remark": values.remark,
            "kapha": kaphaValue,
            "pitta": pittaValue,
            "vata": vataValue,
            "status": false,
            "typeOfHerb": values.typeOfHerb,
            "herb_tag": arrayOfSelectedDropdownValue,

        }

        // get the login user id 
        // console.log(localStorage.getItem('id'));
        let loginUserId = localStorage.getItem('id')

        // get the login user id associated with herb
        // console.log(props?.editHerbManagementRecord?.user_id);
        let userId = props?.editHerbManagementRecord?.user_id

        // handle the flag value
        // update flag=false (login user id and recipe nu user id match kari ane flag false hoi to recipe update thai jai and flag= false 
        //     pass karvano)

        // update case 
        if (props.editHerbManagementRecord) {
            // same user id and edit flag is false then update recipe api call (we update our own recipe case)
            if (loginUserId == userId) {
                if (props?.editHerbManagementRecord?.edit_flag == false) {
                    data.edit_flag = false
                    // console.log("1 update", data);
                    // update api
                    UpdateHerb(data)
                }
                if (props?.editHerbManagementRecord?.edit_flag == true) {
                    data.edit_flag = true
                    // console.log("2 update", data);
                    UpdateHerb(data)
                }
            }
            if (userId !== loginUserId) {
                //loginuser and recipe user id doesn't match  and also edit_flag is false then add new recipe
                if (props?.editHerbManagementRecord?.edit_flag == false) {
                    data.edit_flag = true
                    // console.log("2 add", data);
                    // add api
                    addHerb(data)
                }
            }
        } else {
            if (!props.editHerbManagementRecord) {
                // add api
                data.edit_flag = false
                addHerb(data)
            }
        }
        // console.log(data);
    };

    const addHerb = (data) => {
        // console.log("update", data);
        addHerbManagementApi(data)
            .then((res) => {
                if (res.status == 200) {
                    form.setFieldsValue({ 'name': '' })
                    notification.success({
                        message: "Herb added successfully",
                    });
                    props.getListOfHerbsManagement()
                    setButtonName('SAVE')
                    resetData()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }
    const UpdateHerb = (data) => {
        // console.log("update", props.editHerbManagementRecord.id, data);
        updateHerbManagementApi(props.editHerbManagementRecord.id, data)
            .then((res) => {
                if (res.status == 200) {
                    setButtonName("ADD")
                    notification.success({
                        message: "Herb Update successfully",
                    });
                    setButtonName('SAVE')
                    props.getListOfHerbsManagement()
                    resetData()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }
    const resetData = () => {
        form.resetFields()
        setKaphaValue(false)
        setPittaValue(false)
        setVataValue(false)
        setPhenoTypeErrMsg('')
    };
    return (

        <div className="AddHerb">
            <Form
                name="AddHerbForm"
                className="AddHerbForm"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 2 }]} className="align-self-center">
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Herb Name
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="herb_name" rules={[
                            {
                                required: true,
                                message: "Please Enter Herb Name!",
                            },
                            {
                                pattern: CHARACTER_PATTERN,
                                message: CHARACTER_PATTERN_MESSAGE,
                            }
                        ]}>
                            <Input placeholder="Enter Name" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Quantity
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="quantity"
                            rules={[
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please Enter Valid Data!",
                                },
                                {
                                    required: true,
                                    message: "Please Enter Quantity!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Quantity" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Unit
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="unit"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Unit!",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Unit"
                                className="w-100 mt-2 p-1"
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            >
                                {unitOptionsList.length > 0 && unitOptionsList.map(option => (
                                    <Option value={option.id} key={option.id}>{option.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Remark
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="remark"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Remark!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Remark" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={7} >
                        <label className="form-input-label">
                            Phenotypes
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <span className="d-flex">
                            <Form.Item name="kapha"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: "Please Select Herbs!",
                            //     },
                            // ]}
                            >
                                <Checkbox checked={kaphaValue} value={kaphaValue} onChange={(e) => setKaphaValue(!kaphaValue)} >Kapha</Checkbox>
                            </Form.Item>
                            <Form.Item name="pitta"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: "Please Select Herbs!",
                            //     },
                            // ]}
                            >
                                <Checkbox checked={pittaValue} value={pittaValue} onChange={(e) => setPittaValue(!pittaValue)} >Pitta</Checkbox>
                            </Form.Item>
                            <Form.Item name="vata"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: "Please Select Vata!",
                            //     },
                            // ]}
                            >
                                <Checkbox checked={vataValue} value={vataValue} onChange={(e) => setVataValue(!vataValue)} >Vata</Checkbox>
                            </Form.Item>
                        </span>
                        <p className="text-danger">{phenoTypeErrMsg}</p>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={9}>
                        <label className="form-input-label">
                            Type Of Herbs
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="typeOfHerb"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Types Of Herb!",
                                },
                            ]}
                        >
                            <Radio.Group className="mt-2 ">
                                <Radio value="Kitchen Herb"> Kitchen Herb</Radio>
                                {/* Ayurveda Medicine" is visible to "Ayurveda Doctor" */}
                                {(nutritionistType == 'Ayurveda Doctor' || userRole == "Admin") && <Radio value="Ayurveda Medicine">Ayurveda Medicine</Radio>}
                                {/* "Allopathic Medicine" is visible to "Allopathic Doctor" and "Ayurveda Doctor" */}
                                {/* {(userRole == "Admin" || nutritionistType == 'Allopathic Doctor') && <Radio value="Allopathic Medicine">Allopathic Medicine</Radio>} */}
                            </Radio.Group>
                        </Form.Item>

                    </Col>

                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Nutrient Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="nutrient_tags"
                            rules={[
                                { required: false, message: "Please Select Nutrient Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Nutrient Tags"
                                allowClear
                                showSearch
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                // maxLength={2}
                                maxLength="2"
                                mode="multiple"
                                className="mt-2"
                            >
                                {recipeTagsOptions && recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Nutrient Tags' &&
                                    <Option
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                                {/* {NutrientTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Cuisine Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="cuisine_tags"
                            rules={[
                                { required: false, message: "Please Select Cuisine Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Cuisine Tags"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                // maxLength={2}
                                // maxLength="2"
                                mode="multiple"
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Cuisine Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                                {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Type of Diet Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="type_of_diet_tag"
                            rules={[
                                { required: false, message: "Please Select Type Of Diet Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Type Of Diet Tags"
                                allowClear
                                showSearch
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                maxTagCount="responsive"
                                // maxLength={2}
                                mode="multiple"
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Type of Diet Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // }
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={6}>
                        <label className="form-input-label">
                            Cooking Method Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="cooking_method_tag"
                            rules={[
                                { required: false, message: "Please Select Cooking Method Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Recipe by Cooking Method Tags"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                maxTagCount="responsive"
                                // maxLength={2}
                                mode="multiple"
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Recipe by Cooking Method Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // }
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                                {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Recipe By Season Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="recipe_by_season_tag"
                            rules={[
                                { required: false, message: "Please Select Recipe By Season Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Recipe by Season Tags"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Recipe by seasons Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 2
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Recipe Difficulty Level Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="recipe_difficulty_level_tag"
                            rules={[
                                { required: false, message: "Please Select Recipe Difficulty Level Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Recipe by difficulty level Tags"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Recipe by difficulty level Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Other Tags
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="other_tag"
                            rules={[
                                { required: false, message: "Please Select Other Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Other Tags"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Other Tags' &&
                                    <Option
                                        //  disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={12} xl={11} xxl={8}>

                        <label className="form-input-label">
                            Select Allergy Tags:
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="allergy_tag"
                            rules={[
                                { required: false, message: "Please Select Allergy Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Allergy present in This Recipe"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Allergy Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                                {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Select Disease Tags:
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="disease_tag"
                            rules={[
                                { required: false, message: "Please Select Disease Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Diseases for which this Recipe is NOT recommanded"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Disease Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // } 
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Select Goal Tags:
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="goal_tag"
                            rules={[
                                { required: false, message: "Please Select Goal Tags!" },
                            ]}
                        >
                            <Select
                                placeholder="Select Goal for which this Recipe is recomanded"
                                allowClear
                                showSearch
                                // onChange={handleChange}
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                maxTagCount="responsive"
                                mode="multiple"
                                onSelect={(e) => CreateArrayOfSelectedValue(e, 'add')}
                                onDeselect={(e) => CreateArrayOfSelectedValue(e, 'remove')}
                                className="mt-2"
                            >
                                {recipeTagsOptions.length > 0 && recipeTagsOptions.map((element) =>
                                    element.tagType == 'Goal Tags' &&
                                    <Option
                                        // disabled={
                                        //     optionsSelected.length > 1
                                        //         ? optionsSelected.includes(element)
                                        //             ? false
                                        //             : true
                                        //         : false
                                        // }
                                        key={element.id} value={element.id}>{element.name}</Option>
                                )}
                                {/* {CuisineTagsOptions.map(option => (
                                    <Option disabled={
                                        optionsSelected.length > 1
                                            ? optionsSelected.includes(option)
                                                ? false
                                                : true
                                            : false
                                    } key={option.id}>{option.name}</Option>
                                ))} */}
                            </Select>
                        </Form.Item>
                    </Col>



                    <Col xs={24} md={16} xl={24} xxl={24} className="align-self-center text-center">
                        <Button htmlType="submit" className="submit-btn border-0 rounded ">
                            {/* {props.editHerbManagementRecord ? 'Update' : 'Save Herb'} */}
                            {buttonName}
                        </Button>
                        <Button onClick={() => resetData()} className="reset-btn ms-3 b-0 rounded">
                            RESET
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div >
    )
}